import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import useCurrentUserId from './useCurrentUserId';

const useAllRUAIdsByAlbum = (albumId: string | undefined) : string[] => {
  const userId = useCurrentUserId();
  const ruaDb = useSelector((state: RootState) => state.relationUserAlbumDb);
  const ids = Object.keys(ruaDb.relationUserAlbums).filter(id => {
    return ruaDb.relationUserAlbums[id].albumId === albumId && ruaDb.relationUserAlbums[id].userId === userId;
  });

  return ids;
}

export default useAllRUAIdsByAlbum;
